import Reports from "../../common/reports/Reports";
import _, { set } from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import GlobalContext from "../../framework/GlobalContext";
import classes from "./index.module.css";
import DistributorReportSummary from "./DistributorReportSummary";
import Autocomplete from "../../framework/Autocomplete";
import AddDistributor from "./addDistributor";
import DistributorReportFilter from "./DistributorReportFilter";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
const Distributor = () => {
  const [showAddDistributor, setShowAddDistributor] = useState(false);
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterStates, setFilterStates] = useState(null);
  const [distributorRowEditData, setDistributorRowEditData] = useState(null);
  const { currentComponent, setCurrentComponent } = useContext(GlobalContext);
  const [refreshData, setRefreshData] = useState(false);
  const [filterParams, setFilterParams] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const reportRef = useRef();
  const editRef = useRef();
  const refreshRef = useRef();
  const addDistributor = useCallback((isEdit = false) => {
    if (isEdit) {
      setDistributorRowEditData(() => reportRef.current.getCurrentRowData());
    }
    setShowAddDistributor(true);
  }, []);

  // const debounceAddDistributor = useCallback(_.debounce(addDistributor, 200), [
  //   addDistributor,
  // ]);

  const closeDistributorAc = useCallback(() => {
    setShowAddDistributor(false);
    setCurrentComponent("grid_reports");
    refreshRef.current.click();
    setDistributorRowEditData(null);
  }, [setCurrentComponent]);
  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={editRef}
        startIcon={<Shortcut keys={["Ctrl", "E"]} />}
        label="Edit"
        onClick={() => {
          //debounceAddDistributor(true);
          addDistributor(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [addDistributor, currentRowData]);

  const debounceCloseDistributorAc = _.debounce(closeDistributorAc, 200);

  const listener = useCallback(
    (e) => {
      const key = e.key?.toLowerCase();
      const ctrlKey = e.ctrlKey;
      const altKey = e.altKey;
      if (altKey && key === "r") {
        e.preventDefault();
        setRefreshData(true);
        return;
      }
      if (ctrlKey && key === "e") {
        e.preventDefault();
        if (currentRowData) {
          return editRef.current.click();
        }
      }
      if (ctrlKey && key === "d") {
        e.preventDefault();
        return addDistributor();
      }
    },
    [addDistributor, currentRowData]
  );
  const applyFilterHandler = useCallback((params, filterStates) => {
    setRefreshData(false);
    setFilterParams(params);
    setFilterStates(filterStates);
  }, []);
  useEffect(() => {
    if (
      !onFilterShow &&
      !showAddDistributor &&
      !onColumnShow &&
      currentComponent === "grid_reports"
    ) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [
    currentComponent,
    listener,
    onColumnShow,
    onFilterShow,
    showAddDistributor,
  ]);
  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);
    }
  }, [refreshData]);
  return (
    <div className={classes["distributor-report-container"]}>
      <Reports
        identifier="distributor"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        filterStates={filterStates}
        filterParams={filterParams}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        filters={
          <DistributorReportFilter
            reportRef={reportRef}
            refreshData={refreshData}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            onFilterShow={onFilterShow}
            applyFilters={applyFilterHandler}
          />
        }
        currentRow={(data) => {
          setCurrentRowData(data);
        }}
      />
      <DistributorReportSummary
        refreshData={() => {
          setRefreshData(true);
        }}
        refreshRef={refreshRef}
        showAutoComplete={() => {
          addDistributor();
        }}
      />
      <Autocomplete
        show={showAddDistributor}
        height="80%"
        width="90%"
        closeAutoComplete={debounceCloseDistributorAc}
      >
        <AddDistributor
          distributorRowEditData={distributorRowEditData}
          onEscape={closeDistributorAc}
          onSaveDistributor={() => {
            setRefreshData(true);
            closeDistributorAc();
          }}
        />
      </Autocomplete>
    </div>
  );
};

export default Distributor;
